"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCATION_TYPE = void 0;
exports.LOCATION_TYPE = ['administrative', 'city', 'postcode', 'town', 'postal_code'];
